import css from './accordion-item.module.css'

export const styles = {
  base: css.item,
  heading: css.heading,
  trigger: css.trigger,
  icon: css.icon,
  title: css.title,
  action: css.action,
  panel: css.panel,
}
